import React from 'react';
import { Link } from 'react-router-dom';
import { Table } from 'rsuite';

const stripQuotes = (str) => {
   if (str.charAt(0) === '"' && str.charAt(str.length -1) === '"') {
    return str.substring(1, str.length - 1);
   }
   return str;
}

const FormattedCell = ({ rowData, dataKey, rowIndex, config, ...props }) => {
  const getLabel = (label) => {
    if (!label) {
      if (config.fill_zeros) {
        return 0;
      }
      return '';
    }
    if (Array.isArray(label) && typeof label[0] == 'string') {
      return <Link to={`/engagement/summary?${label[1]}=${label[2]}`}>{stripQuotes(label[0])}</Link>;
    }
    if (config.number_format === 'percentage' && typeof label === 'number') {
      return (label * 100).toFixed(2) + '%';
    }
    // show integers with commas
    if (Number.isInteger(label)) {
      return label.toLocaleString();
    }
    if (typeof label === 'string') {
      return stripQuotes(label);
    }
    return label;
  }
  return (
    <Table.Cell {...props}>
      {getLabel(rowData[dataKey])}
    </Table.Cell>
  );
}

function NestedTable({ headings, data, config, wideFirstColumn }) {
  const tableWidth = headings.length * 150 + (wideFirstColumn ? 350 : 0);
  const groups = []
  const hierarchy = config.headings_hierarchy;
  let currentGroup = '';
  headings.forEach((heading) => {
    if (!currentGroup || heading[hierarchy[0]] !== currentGroup) {
      currentGroup = heading[hierarchy[0]];
      groups.push(currentGroup);
    }
  });
  const getData = () => {
    // sort data by date field, string comparison
    console.log(data);
    if ('date' in data[0]) {
      return data.sort((a, b) => {
        return b['date'].localeCompare(a['date']);
      });
    }
    return data;
  };
  return (
    <Table
        data={getData()}
        height={600}
        width={tableWidth}
        headerHeight={80}
      >
        {groups.map((group, groupIndex) => {
          const groupHeadings = headings.filter((heading) => heading[hierarchy[0]] === group);
          return (
            <Table.ColumnGroup header={group} key={groupIndex}>
              {groupHeadings.map((heading, index) => {
                const headkey = heading._data_label;
                const colWidth = index === 0 && wideFirstColumn ? 500 : 150;
                return <Table.Column key={index} width={colWidth} align="left">
                  <Table.HeaderCell>{heading._total ? 'Total' : heading[hierarchy[1]]}</Table.HeaderCell>
                  <FormattedCell dataKey={headkey} config={config} />
                </Table.Column>
              })}
            </Table.ColumnGroup>
          )
        })}
      </Table>
  );
}

function TimeSeriesTable({ headings, data, config, wideFirstColumn }) {
  const tableWidth = headings.length * 150 + (wideFirstColumn ? 350 : 0);
  const [sortColumn, setSortColumn] = React.useState();
  const [sortType, setSortType] = React.useState();
  if (config.nested) {
    return NestedTable({ headings, data, config, wideFirstColumn });
  }
  const getData = () => {
    if (sortColumn && sortType) {
      return data.sort((a, b) => {
        let x = a[sortColumn];
        let y = b[sortColumn];
        if (typeof x === 'string') {
          return sortType === 'asc' ? x.localeCompare(y) : y.localeCompare(x);
        }
        if (sortType === 'asc') {
          return x - y;
        } else {
          return y - x;
        }
      });
    }
    return data;
  };

  const handleSortColumn = (sortColumn, sortType) => {
    setSortColumn(sortColumn);
    setSortType(sortType);
  };

  return (
    <div>
      <Table
        data={getData()}
        height={400}
        width={tableWidth}
        onSortColumn={handleSortColumn}
        sortColumn={sortColumn || 'date'}
        sortType={sortType || 'asc'}
      >
        {headings.map((heading, index) => {          
          const colWidth = index === 0 && wideFirstColumn ? 500 : 150;
          return <Table.Column key={index} width={colWidth} align="left" sortable on>
            <Table.HeaderCell>{heading}</Table.HeaderCell>
            <FormattedCell dataKey={heading} config={config} />
          </Table.Column>
        })}
      </Table>
    </div>
  )
}

export default TimeSeriesTable;